import { injectScope } from "@/utils/lang/util";
import type { Lang } from "@noli/core";

export enum Draft_Words {
  "error-message" = "error-message",
  "balance-not-enough-message" = "balance-not-enough-message",
  "submit" = "submit",
  "cost" = "cost",
  "textarea-placeholder" = "textarea-placeholder",
  "draft-model-select" = "draft-model-select",
  "resolution" = "resolution",
  "resolution-normal" = "resolution-normal",
  "resolution-hq" = "resolution-hq",
  "resolution-hd" = "resolution-hd",
}

export enum Draft_Model_Words {
  sd = "sd",
  sd_20 = "sd_20",
  pixiv = "pixiv",
  pixiv_hand = "pixiv_hand",
  game_icon = "game_icon",
  indoor_design = "indoor_design",
  "architecture" = "architecture", //建筑模型
  "comic" = "comic", //漫画模型
  "arcane" = "arcane", //双城之战
  "food" = "food", //食物模型
  "pixel" = "pixel", //像素模型
  "retro" = "retro", //复古漫画
  "photo" = "photo", //照片质感
  "dream_art" = "dream_art", //梦幻画风
  "oil_paint" = "oil_paint", //油画质感
  "acg" = "acg", //ACG
  "soft" = "soft", //柔和氛围感
  "3D" = "3D", //3D概念设计
  "sam" = "sam", //手绘插画
  "inkpunk" = "inkpunk", //墨水朋克
  "petal" = "petal", //花瓣背景
  "3D_icon" = "3D_icon", //3D图标
  "cartoon_wallpaper" = "cartoon_wallpaper", //动漫壁纸
  "character_simulation" = "character_simulation", //人物仿真
  "antique_photo" = "antique_photo", //古风照片
  "crayon" = "crayon", //蜡笔画
  "colorful_art" = "colorful_art", //多彩艺术
  "2_5D_antique" = "2_5D_antique", //2.5D古风
}
injectScope("draft", Draft_Words);

// 要记得把这个 xxxLangRecords，引用到 src\thirdParty\lang.ts 中的 allThirdPartyLangRecords 里头

export const draftLangRecords: Record<Lang, Record<Draft_Words, string>> = {
  zh: {
    [Draft_Words["error-message"]]: "生成失败",
    [Draft_Words["balance-not-enough-message"]]: "画力星余额不足",
    [Draft_Words["submit"]]: "生成并添加",
    [Draft_Words["cost"]]: "消耗 $ 画力星",
    [Draft_Words["textarea-placeholder"]]: "输入文字，比如：“一朵红色玫瑰花，水彩”",
    [Draft_Words["draft-model-select"]]: "Draft 模型管线",
    [Draft_Words["resolution"]]: "清晰度",
    [Draft_Words["resolution-normal"]]: "标准",
    [Draft_Words["resolution-hq"]]: "优质",
    [Draft_Words["resolution-hd"]]: "高清",
  },
  en: {
    [Draft_Words["error-message"]]: "Generate failed",
    [Draft_Words["balance-not-enough-message"]]: "Heart coin not enough",
    [Draft_Words["submit"]]: "Generate & Add",
    [Draft_Words["cost"]]: "With $ heart coins",
    [Draft_Words["textarea-placeholder"]]: "Input Texts",
    [Draft_Words["draft-model-select"]]: "Draft Model",
    [Draft_Words["resolution"]]: "Resolution",
    [Draft_Words["resolution-normal"]]: "Norm",
    [Draft_Words["resolution-hq"]]: "HQ",
    [Draft_Words["resolution-hd"]]: "HD",
  },
};

export const draftModelRecords: Record<Lang, Record<Draft_Model_Words, string>> = {
  zh: {
    [Draft_Model_Words["sd"]]: "通用1.0",
    [Draft_Model_Words["sd_20"]]: "通用2.0",
    [Draft_Model_Words["pixiv"]]: "二次元",
    [Draft_Model_Words["pixiv_hand"]]: "手部优化",
    [Draft_Model_Words["game_icon"]]: "游戏icon",
    [Draft_Model_Words["indoor_design"]]: "室内设计",
    [Draft_Model_Words["architecture"]]: "建筑模型",
    [Draft_Model_Words["comic"]]: "漫画模型",
    [Draft_Model_Words["arcane"]]: "双城之战",
    [Draft_Model_Words["food"]]: "食物模型",
    [Draft_Model_Words["pixel"]]: "像素模型",
    [Draft_Model_Words["retro"]]: "复古漫画",
    [Draft_Model_Words["photo"]]: "照片质感",
    [Draft_Model_Words["dream_art"]]: "梦幻画风",
    [Draft_Model_Words["oil_paint"]]: "油画质感",
    [Draft_Model_Words["acg"]]: "ACG",
    [Draft_Model_Words["soft"]]: "柔和氛围",
    [Draft_Model_Words["3D"]]: "3D概念",
    [Draft_Model_Words["sam"]]: "手绘插画",
    [Draft_Model_Words["inkpunk"]]: "墨水朋克",
    [Draft_Model_Words["petal"]]: "花瓣背景",
    [Draft_Model_Words["3D_icon"]]: "3D图标",
    [Draft_Model_Words["cartoon_wallpaper"]]: "动漫壁纸",
    [Draft_Model_Words["character_simulation"]]: "人物仿真",
    [Draft_Model_Words["antique_photo"]]: "古风照片",
    [Draft_Model_Words["crayon"]]: "蜡笔画",
    [Draft_Model_Words["colorful_art"]]: "多彩艺术",
    [Draft_Model_Words["2_5D_antique"]]: "2.5D古风",
  },
  en: {
    [Draft_Model_Words["sd"]]: "Universal 1.0",
    [Draft_Model_Words["sd_20"]]: "Universal 2.0",
    [Draft_Model_Words["pixiv"]]: "Anime",
    [Draft_Model_Words["pixiv_hand"]]: "Hand optimization",
    [Draft_Model_Words["game_icon"]]: "Game Icon",
    [Draft_Model_Words["indoor_design"]]: "Indoor Design",
    [Draft_Model_Words["architecture"]]: "Arch",
    [Draft_Model_Words["comic"]]: "Comic",
    [Draft_Model_Words["arcane"]]: "Arcane",
    [Draft_Model_Words["food"]]: "Food",
    [Draft_Model_Words["pixel"]]: "Pixel",
    [Draft_Model_Words["retro"]]: "Retro",
    [Draft_Model_Words["photo"]]: "Photo",
    [Draft_Model_Words["dream_art"]]: "Dream art",
    [Draft_Model_Words["oil_paint"]]: "Oil paint",
    [Draft_Model_Words["acg"]]: "Acg",
    [Draft_Model_Words["soft"]]: "Soft",
    [Draft_Model_Words["3D"]]: "3D",
    [Draft_Model_Words["sam"]]: "Sam",
    [Draft_Model_Words["inkpunk"]]: "Inkpunk",
    [Draft_Model_Words["petal"]]: "Petal",
    [Draft_Model_Words["3D_icon"]]: "3D icon",
    [Draft_Model_Words["cartoon_wallpaper"]]: "Cartoon",
    [Draft_Model_Words["character_simulation"]]: "Simulation",
    [Draft_Model_Words["antique_photo"]]: "Antique",
    [Draft_Model_Words["crayon"]]: "Crayon",
    [Draft_Model_Words["colorful_art"]]: "Colorful",
    [Draft_Model_Words["2_5D_antique"]]: "2.5D Antique",
  },
};
